import { Button } from '@ps/isp-web-component-library';
import { Translation } from '@ps/web-shared-components';
import type { ComponentProps } from 'react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTWCL_Update_Currency } from './UpdateCurrencyButton.messages.json';

const preferredCurrencyPath = '/account/cashier/preferred-currency';

const UpdateCurrencyButton: React.FC<ComponentProps<typeof Button>> = (props) => {
  const { modal } = useDispatch<Dispatch>();
  const isEmbedded = useSelector(select.device.isEmbedded);
  const cashierHref = useSelector(select.cms.getCashierHref);

  return (
    <Button
      {...props}
      onClick={(evt: React.MouseEvent) => {
        if (!isEmbedded) {
          evt.preventDefault();
          modal.enqueue({ path: preferredCurrencyPath });
        }
      }}
      href={cashierHref}
      as={isEmbedded ? 'a' : undefined}
      size="medium"
    >
      <Translation {...TXTWCL_Update_Currency} />
    </Button>
  );
};

export default UpdateCurrencyButton;
